<template>
  <el-dialog
    class="teachers-day"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    top="10vh"
    width="960px"
    center
  >
    <div class="content">
      <h3>亲爱的老师：</h3>
      <p style="margin-top: 3px; white-space: nowrap">
        您好！过去的一年您用辛勤培养祖国的未来，感谢您的付出！猫猫特别为您献上一份教师节好礼，祝福您节日快乐！
      </p>
      <div class="method" style="margin-top: 5px">福利领取方法：</div>
      <div style="margin-left: 98px">
        <p>
          <span class="tag">福利一</span
          >点击选择下方2个课包中任意一个课程标签，进行确认领取即可<strong class="green"
            >开通课包前6节</strong
          >
        </p>
        <p>
          <span class="tag">福利二</span
          >9月期间使用此课包开课≥2次，同时班级学生提交作品≥30个，<strong class="green"
            >可领取全套12节</strong
          >，完成任务还有机会<strong class="green">参与优秀课堂评选，获赠编程猫精美周边</strong>
        </p>
      </div>
      <div class="open-box">
        <div class="loading" v-if="loading" v-loading="loading"></div>
        <ul class="course-list" v-if="!received && loading === false">
          <li
            v-for="(item, i) in courses"
            :key="item.id"
            :class="{ active: selected === i }"
            @click="selectCourse(i)"
          >
            <i class="icon-selected"></i>
            <img class="img" :src="item.avatarUrl" />
            <div class="desc">
              <div class="name" :title="item.name">{{ item.name }}</div>
              <p class="count">
                <icon-lesson-count class="icon-lesson-count" />{{ item.lessonAmount }}课时
              </p>
            </div>
          </li>
        </ul>
        <div class="received-box" v-if="received && loading === false">
          <img class="img" :src="detail.avatarUrl" />
          <div class="result">
            <h4 class="title"><i class="icon-success"></i>领取课程成功</h4>
            <p>
              您或学校其他老师，已于 {{ formatDate(detail.receiveTime) }} 领取《{{
                detail.name
              }}》课程
            </p>
          </div>
        </div>
      </div>
      <el-button
        v-if="!received && loading === false"
        :loading="receiving"
        class="btn-receive"
        type="primary"
        size="medium"
        @click="receive"
        >立即领取</el-button
      >
      <el-button v-if="received && loading === false" class="btn-view" type="primary" size="medium" @click="toCourse"
        >查看课程</el-button
      >
      <p class="tips">*更多活动详情，请点击首页右上角“平台答疑”扫码加入服务群</p>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { formatDate } from '@/utils/utils'
import { reportEvent } from '@/utils/sensor'
import IconLessonCount from '@/assets/svg/icon_lesson_count.svg'

export default {
  components: {
    IconLessonCount
  },
  data() {
    return {
      visible: false,
      loading: false,
      receiving: false, // 领取中
      selected: -1, // 选中课包
      received: false, // 已领取
      courses: [], // 课包列表
      detail: null // 已领取课包
    }
  },
  computed: {
    ...mapState(['user']),
    isTeacher() {
      return this.user && (this.user.role_id === 10001 || this.user.role_id === 10002)
    }
  },
  watch: {
    user() {
      this.interceptShow()
    },
    '$route.path'() {
      this.interceptShow()
    },
    isTeacher() {
      this.interceptShow()
    }
  },
  methods: {
    formatDate,
    interceptShow() {
      if (
        this.user &&
        this.user.id &&
        this.isTeacher &&
        this.$route.path === '/dashboard' &&
        this.visible === false
      ) {
        this.show()
      }
    },
    show(force) {
      const showeds = JSON.parse(localStorage.getItem('visibleTeachersDaySecond') || '[]')
      const showed = showeds.includes(this.user.id)
      if ((force || !showed) && this.checkDate()) {
        this.visible = true
        if (!showed) {
          showeds.push(this.user.id)
          localStorage.setItem('visibleTeachersDaySecond', JSON.stringify(showeds))
        }
        this.fetchPackages()
      }
    },
    // 检查日期
    checkDate() {
      return moment().isBetween(moment('2022/09/08'), moment('2022/09/26'))
    },
    // 获取课包列表
    async fetchPackages() {
      this.loading = true
      let receiveStatus = '未领取'
      try {
        const { data } = await API.post('/edu/zone/activity/list/activity/package')
        this.loading = false
        const item = data.find((el) => el.receivePackage === true)
        if (item) {
          receiveStatus = '已领取'
          this.received = true
          this.detail = item
        } else {
          this.received = false
          this.courses = data
        }
      } catch {
        receiveStatus = '请求异常'
        this.loading = false
        this.received = false
      }
      // 埋点统计
      this.report('Teachers_Day_Show', receiveStatus)
    },
    // 上报
    report(key, status) {
      reportEvent(key, { status })
    },
    selectCourse(i) {
      this.selected = i
    },
    async receive() {
      if (this.selected === -1) {
        this.$message.warning('请先选择课程')
        return
      }
      const course = this.courses[this.selected]
      let code = '领取失败'
      try {
        this.receiving = true
        await API.post(
          '/edu/zone/activity/open/package',
          { packageId: course.packageId },
          { ignoreMsg: true }
        )
        this.receiving = false
        code = '领取成功'
        this.received = true
        this.detail = {
          ...course,
          receiveTime: moment().unix()
        }
      } catch (e) {
        code = `请求异常：${e.error_code}`
        this.receiving = false
        this.received = false
        if (e.error_code === 800024) {
          // 课包已领取
          this.fetchPackages()
        } else {
          this.$message.error('领取失败，请稍后重试')
        }
      }
      // 埋点统计
      this.report('Teachers_Day_Receive', code)
    },
    toCourse() {
      this.visible = false
      sessionStorage.setItem('courseType', 'offical')
      this.$router.push(
        `/courseManage/list/${this.detail.packageId}?topicId=${this.detail.topicId}&pacakgeEntryType=1`
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.teachers-day {
  ::v-deep {
    .el-dialog {
      height: 575px;
      background: image-set(
          url(../../assets/image/bg_teachers_day.png) 1x,
          url(../../assets/image/bg_teachers_day@2x.png) 2x
        )
        no-repeat 0 0 / 100% auto;
      box-shadow: none;
    }
    .el-dialog__headerbtn {
      top: 35px;
      right: 23px;
      font-size: 18px;
      .el-dialog__close {
        &:hover {
          color: #fff;
        }
      }
    }
    .el-dialog__body {
      padding: 0;
      color: #333;
    }
  }
  .content {
    padding: 125px 70px 0;
    h3 {
      font-size: 16px;
      font-weight: 500;
    }
    p {
      font-size: 14px;
      line-height: 2;
    }
    .method {
      float: left;
    }
    .tag {
      margin-right: 5px;
      padding: 1px 8px;
      color: #00c4aa;
      border: 1px solid #00c4aa;
      background: rgba($color: #00c4aa, $alpha: 0.1);
      border-radius: 2px;
      font-size: 12px;
    }
    .green {
      color: #00c4aa;
    }
    .open-box {
      margin-top: 10px;
      .loading {
        height: 140px;
        :global(.el-loading-mask) {
          background: transparent;
        }
      }
    }
    .course-list {
      display: flex;
      justify-content: space-between;
      li {
        position: relative;
        display: flex;
        align-items: center;
        padding: 9px;
        width: 400px;
        background: #fff;
        border: 1px solid #e1e1e1;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 rgba(#1d4937, 0.06);
        cursor: pointer;
        transition-duration: 0.3s;
        &:hover {
          border-color: #00c4aa;
          box-shadow: 0 2px 4px 0 rgba(#1d4937, 0.2);
        }
        &.active {
          border-color: #00c4aa;
          box-shadow: 0 2px 4px 0 rgba($color: #1d4937, $alpha: 0.06);
          .icon-selected {
            opacity: 1;
          }
        }
        &:last-child {
          margin-right: 0;
        }
        .icon-selected {
          position: absolute;
          top: 0;
          right: 0;
          width: 40px;
          height: 40px;
          opacity: 0;
          background: image-set(
              url(../../assets/image/icon_selected.png) 1x,
              url(../../assets/image/icon_selected@2x.png) 2x
            )
            no-repeat 0 0 / 100% auto;
          transition-duration: 0.3s;
        }
        .desc {
          overflow: hidden;
        }
        .name {
          font-size: 18px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .count {
          margin-top: 8px;
          color: #666;
          font-size: 12px;
        }
        .icon-lesson-count {
          margin: 0 3px -1px 0;
          width: 12px;
        }
      }
    }
    .received-box {
      display: flex;
      align-items: center;
      padding: 9px;
      border: 1px solid #00c4aa;
      border-radius: 4px;
      .result {
        .icon-success {
          display: inline-block;
          margin: 2px 6px 0 0;
          width: 20px;
          height: 20px;
          background: image-set(
              url(../../assets/image/icon_success.png) 1x,
              url(../../assets/image/icon_success@2x.png) 2x
            )
            no-repeat 0 0 / 100% auto;
          vertical-align: top;
        }
        .title {
          margin-bottom: 3px;
          font-size: 18px;
          font-weight: 400;
        }
        p {
          margin-left: 26px;
          color: #666;
        }
      }
    }
    .img {
      display: block;
      margin-right: 15px;
      width: 160px;
      height: 120px;
      border-radius: 2px;
      object-fit: cover;
    }
    .btn-receive,
    .btn-view {
      display: block;
      margin: 22px auto 0;
      padding: 12px 20px;
      width: 174px;
      font-size: 16px;
    }
    .btn-view {
      background: #00c4aa;
      border-color: #00c4aa;
    }
    .tips {
      position: absolute;
      bottom: 12px;
      left: 70px;
      color: #bea33e;
      font-size: 12px;
    }
  }
}
</style>
